import PropTypes from 'prop-types';
import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Typography, Divider } from '@mui/material';
// hooks
import useActiveLink from '../../../hooks/useActiveLink';
//
import { StyledPopover } from './styles';
import NavItem from './NavItem';

// ----------------------------------------------------------------------

export default function NavList({ data, depth, hasChild }) {
    const navRef = useRef(null);

    const { pathname } = useLocation();

    const { active, isExternalLink } = useActiveLink(data.path);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open) {
            handleClose();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    useEffect(() => {
        const appBarEl = Array.from(document.querySelectorAll('.MuiAppBar-root'));

        // Reset styles when hover
        const styles = () => {
            document.body.style.overflow = '';
            document.body.style.padding = '';
            // Apply for Window
            appBarEl.forEach((elem) => {
                elem.style.padding = '';
            });
        };

        if (open) {
            styles();
        } else {
            styles();
        }
    }, [open]);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <NavItem
                ref={navRef}
                item={data}
                depth={depth}
                open={open}
                active={active}
                isExternalLink={isExternalLink}
                onMouseEnter={handleOpen}
                onMouseLeave={handleClose}
            />

            {hasChild && (
                <StyledPopover
                    open={open}
                    anchorEl={navRef.current}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{
                        onMouseEnter: handleOpen,
                        onMouseLeave: handleClose,
                    }}
                >
                    <Typography
                        variant="overline"
                        sx={{ px: 2, pt: 0.5, pb: 1, display: 'block', color: 'text.secondary', fontSize: 11, letterSpacing: 1 }}
                    >
                        {data.title}
                    </Typography>
                    <Divider sx={{ mb: 0.5, borderStyle: 'dashed' }} />
                    <NavSubList data={data.children} depth={depth} />
                </StyledPopover>
            )}
        </>
    );
}

// ----------------------------------------------------------------------

function NavSubList({ data, depth }) {
    return (
        <>
            {data.map((list) => {
                if (list.divider) return null;
                return (
                    <NavList
                        key={list.title + list.path}
                        data={list}
                        depth={depth + 1}
                        hasChild={!!list.children}
                    />
                );
            })}
        </>
    );
}

NavList.propTypes = {
    data: PropTypes.object,
    depth: PropTypes.number,
    hasChild: PropTypes.bool,
};

NavSubList.propTypes = {
    data: PropTypes.array,
    depth: PropTypes.number,
};